<template>
    <div class="read-original">
        <div class="original-info">
            <div class="info-top">
                <div class="top-pic">
                    <img width="100%" height="100%" src="../../../assets/images/subject/zt_shl.jpg" alt="">
                </div>
                <div class="top-txt">
                    《伤寒论》一书确立了六经辨证体系。运用四诊八纲，对伤寒各阶段的辨脉、审证、论治、立方、用药规律等，以条文的形式作了较全面的阐述。本书记载了397法，113方，总结前人的医学成就和丰富的实践经验，集汉代以前医学之大成，并结合自己的临床经验，系统地阐述了多种外感疾病及杂病的辨证论治，理法方药俱全，在中医发展史上具有划时代的意义和承前启后的作用，对中医学的发展做出了重要贡献。
                </div>
            </div>
            <div class="info-catalogue">目录</div>
            <ul class="info-list">
                <li class="list" v-for="(item,index) in infoList" :key="index">
                    <div class="list-entry">{{ item.label }}</div>
                    <div class="list-levelTwo" v-if="item.children">
                        <div v-for="(levelTwo,two) in item.children" :key="two">
                            <div>{{ levelTwo.label }}</div>
                            <div v-if="levelTwo.children&&levelTwo.children.length!=0" class="list-levelThree">
                                <div v-for="(levelThree,three) in levelTwo.children" :key="three">{{ levelThree.label }}</div>
                            </div>
                        </div>
                        
                    </div>
                    
                </li>
            </ul>
        </div>
        <!-- 树结构 -->
        <!-- <div class="tree_container">
            <el-tree
                :indent="0"
                class="tree-line"
                :data="infoList" 
                :props="defaultProps"
                :highlight-current="true" 
                ref="navTree"
                default-expand-all
                node-key="id"
                @node-click="handleNodeClick"
            >   
                <span slot-scope="{ data }"> 
                    <i v-if="!data.children " class="el-icon-tickets" />  
                    {{ data.label }}
                </span>
            </el-tree> 
        </div>   -->
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            infoList:[
                {
                    label: '序',
                    id:'1',
                    isShow:true,//当前折叠部分是否打开
                    children: [
                        {
                            label: '伤寒论序', 
                            id:'1-1',
                            children: []
                        },
                        {
                            label: '伤寒卒病论集', 
                            id:'1-2',
                            children: [], 
                        },
                    ]
                },
                {
                    label: '卷第二',
                    id:'2',
                    isShow:true,//当前折叠部分是否打开
                    children: [
                        {
                            label: '伤寒例第三', 
                            id:'2-1',
                            children: [], 
                        },
                        {
                            label: '辨太阳病脉证并治法上第五', 
                            id:'2-2',
                            children: [
                                {
                                    label: '四逆汤方', 
                                    id:'2-2-1', 
                                }
                            ], 
                        },
                    ]
                }, 
            ]
        }
    },
    watch: {},
    mounted() {
        
    },
    methods: {
        handleNodeClick(data, node ,el) {     
			if(node.level==2){ 
				this.treeType=data.infoType;
				this.navList=[].concat(data.navList?data.navList:[]);
				this.$nextTick(()=>{
					this.$refs.subject_cont.nav_click(this.navList[0],0)
				})
			}
        }, 
    }
}
</script>
<style lang='less' scoped>
.read-original{ 
    .info-top{
        display: flex;
        justify-content: space-between;
        padding-bottom: 20px;
        border-bottom: 1px solid #386DE8;
        // 主色：#386DE8   浅色：#F1F5FE;
        .top-pic{
            width: 360px;
            height: 180px;
            border-radius: 20px;
            overflow: hidden;
        }
        .top-txt{
            width: 760px; 
            line-height: 40px;
        }
    }
    .info-catalogue{  
        font-size: 22px;
        font-weight: bold; 
        padding-left: 10px;
        border-left: 6px solid #386DE8;
        color: #000;
        line-height: 30px;
        margin: 20px 0;
    }
    .info-list{
        border: 1px solid #386DE8;
        .list{
            padding-left: 20px;
            border-bottom: 1px solid #F1F5FE;
            font-size:16px;
            line-height: 32px;
        }
        .list-levelTwo{
            padding-left: 20px;
        }
        .list-levelThree{
            padding-left: 20px;
        }
    }
}

 
// 树样式
.tree-line{
	::v-deep .el-tree-node{
		position: relative;
		padding-left: 16px; // 缩进量
	}
	::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
		background: red
	}
	::v-deep .el-tree-node__content{
		height: 30px;
		.is-leaf{
			width: 4px;
		} 
	}
	::v-deep .el-tree-node__children{
		padding-left: 16px; // 缩进量
	}
	// 竖线
	::v-deep .el-tree-node::before{
		content:"";
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -24px;
		border-width: 1px;
		border-left: 1px dashed #ccc;
	}
	// 当前层最后⼀个节点的竖线⾼度固定
	::v-deep .el-tree-node:last-child::before{
		height: 38px; // 可以⾃⼰调节到合适数值
	}
	// 横线
	::v-deep .el-tree-node::after{
		content:"";
		width: 24px;
		height: 20px;
		position: absolute;
		left: -3px;
		top: 14px;
		border-width: 1px;
		border-top: 1px dashed #ccc;
	}
	// 去掉最顶层的虚线，放最下⾯样式才不会被上⾯的覆盖了
	& > ::v-deep .el-tree-node::after{
		border-top: none;
	}
	& > ::v-deep .el-tree-node::before{
		border-left: none;
	}
	// 展开关闭的icon
	::v-deep .el-tree-node__expand-icon{
		font-size: 16px;
		// 叶⼦节点（⽆⼦节点）
		::v-deep &.is-leaf{
		color: transparent;
		display: none; // 也可以去掉
		}
	}
}
</style>